import { render } from "./BadConnection.vue?vue&type=template&id=36474392&scoped=true&ts=true"
import script from "./BadConnection.vue?vue&type=script&lang=ts"
export * from "./BadConnection.vue?vue&type=script&lang=ts"

import "./BadConnection.vue?vue&type=style&index=0&id=36474392&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36474392"]])

export default __exports__